<template>
  <spinner v-if="loading" />
  <div v-else-if="stage === 1" class="container-positions">
    <div v-for="(moneyLineGroup, aIx) in groupedMoneyLines1x2" :key="aIx">
      <div
        v-if="moneyLineGroup.awayYes || moneyLineGroup.awayNo"
        class="box-position"
      >
        <!-- Title of box (mySide) -->
        <my-position-header
          :game="game"
          :obj-side="moneyLineGroup"
          :type-bet="'moneyline1x2'"
          :key-obj="aIx"
          :home-away="'away'"
          @change-accordeon-opened="changeAccordeonOpened"
        />
        <div v-if="moneyLineGroup.expandedAway">
          <div v-if="moneyLineGroup.awayYes">
            <my-position-accordeon
              v-if="moneyLineGroup.awayYes.bets.length > 1"
              :obj-side="moneyLineGroup.awayYes"
              :league="league"
              @display-bet="displayBet"
            />
            <my-position-accordeon-item
              v-else
              :obj-side="moneyLineGroup.awayYes"
              :bet="moneyLineGroup.awayYes.bets[0]"
              :league="league"
              @display-bet="displayBet"
            />
          </div>
          <div v-if="moneyLineGroup.awayNo">
            <my-position-accordeon
              v-if="moneyLineGroup.awayNo.bets.length > 1"
              :obj-side="moneyLineGroup.awayNo"
              :league="league"
              @display-bet="displayBet"
            />
            <my-position-accordeon-item
              v-else
              :obj-side="moneyLineGroup.awayNo"
              :bet="moneyLineGroup.awayNo.bets[0]"
              :league="league"
              @display-bet="displayBet"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-for="(moneyLineGroup, aIx) in groupedMoneyLines1x2" :key="aIx">
      <div
        v-if="moneyLineGroup.homeYes || moneyLineGroup.homeNo"
        class="box-position"
      >
        <!-- Title of box (mySide) -->
        <my-position-header
          :game="game"
          :obj-side="moneyLineGroup"
          :type-bet="'moneyline1x2'"
          :key-obj="aIx"
          :home-away="'home'"
          @change-accordeon-opened="changeAccordeonOpened"
        />
        <div v-if="moneyLineGroup.expandedHome">
          <div v-if="moneyLineGroup.homeYes">
            <my-position-accordeon
              v-if="moneyLineGroup.homeYes.bets.length > 1"
              :obj-side="moneyLineGroup.homeYes"
              :league="league"
              @display-bet="displayBet"
            />
            <my-position-accordeon-item
              v-else
              :obj-side="moneyLineGroup.homeYes"
              :bet="moneyLineGroup.homeYes.bets[0]"
              :league="league"
              @display-bet="displayBet"
            />
          </div>
          <div v-if="moneyLineGroup.homeNo">
            <my-position-accordeon
              v-if="moneyLineGroup.homeNo.bets.length > 1"
              :obj-side="moneyLineGroup.homeNo"
              :league="league"
              @display-bet="displayBet"
            />
            <my-position-accordeon-item
              v-else
              :obj-side="moneyLineGroup.homeNo"
              :bet="moneyLineGroup.homeNo.bets[0]"
              :league="league"
              @display-bet="displayBet"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-for="(moneyLineGroup, aIx) in groupedMoneyLines1x2" :key="aIx">
      <div
        v-if="moneyLineGroup.drawYes || moneyLineGroup.drawNo"
        class="box-position"
      >
        <!-- Title of box (mySide) -->
        <my-position-header
          :game="game"
          :obj-side="moneyLineGroup"
          :type-bet="'moneyline1x2'"
          :key-obj="aIx"
          :home-away="'draw'"
          @change-accordeon-opened="changeAccordeonOpened"
        />
        <div v-if="moneyLineGroup.expandedDraw">
          <div v-if="moneyLineGroup.drawYes">
            <my-position-accordeon
              v-if="moneyLineGroup.drawYes.bets.length > 1"
              :obj-side="moneyLineGroup.drawYes"
              :league="league"
              @display-bet="displayBet"
            />
            <my-position-accordeon-item
              v-else
              :obj-side="moneyLineGroup.drawYes"
              :bet="moneyLineGroup.drawYes.bets[0]"
              :league="league"
              @display-bet="displayBet"
            />
          </div>
          <div v-if="moneyLineGroup.drawNo">
            <my-position-accordeon
              v-if="moneyLineGroup.drawNo.bets.length > 1"
              :obj-side="moneyLineGroup.drawNo"
              :league="league"
              @display-bet="displayBet"
            />
            <my-position-accordeon-item
              v-else
              :obj-side="moneyLineGroup.drawNo"
              :bet="moneyLineGroup.drawNo.bets[0]"
              :league="league"
              @display-bet="displayBet"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="stage === 2">
    <button class="button-back mb-1" @click="stage = 1">
      ⇠ Return To Summary
    </button>
    <double-bet-info-modal :bet="session" />
  </div>
</template>

<script setup>
//CORE
import {
  calculateWin,
  getSideString,
  getDrawLabel,
  signOdds,
  fixed2,
  calculateAverageOdds,
} from '@/core/utils';
import {
  commissionAdjustedRisk,
  commissionAdjustedWin,
} from '@/core/commissionUtils';
import { useUserStore } from '@/stores/user';
import { useMiscStore } from '@/stores/store';
import { ref, onMounted } from 'vue';
import { emitter } from '../../../core/emitter';

//COMPONENTS
import MyPositionAccordeon from '@/components/userBets/MyPositionAccordeon.vue';
import MyPositionAccordeonItem from '@/components/userBets/MyPositionSingleBet.vue';
import MyPositionHeader from '@/components/userBets/myPosition/MyPositionHeader.vue';
import Spinner from '@/components/global/Spinner.vue';
import DoubleBetInfoModal from '@/components/userBets/modals/DoubleBetInfoModal.vue';

//PROPS
const props = defineProps({
  game: {
    type: Object,
    default: null,
  },
  moneyLine1x2AwayYes: {
    type: Array,
    required: true,
  },
  moneyLine1x2AwayNo: {
    type: Array,
    required: true,
  },
  moneyLine1x2HomeYes: {
    type: Array,
    required: true,
  },
  moneyLine1x2HomeNo: {
    type: Array,
    required: true,
  },
  moneyLine1x2DrawYes: {
    type: Array,
    required: true,
  },
  moneyLine1x2DrawNo: {
    type: Array,
    required: true,
  },
  moneyLine1x2DrawYesRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2DrawNoRiskWin: {
    type: Object,
    required: true,
  },
  avgOddsMoneyLine1x2: {
    type: Number,
    required: true,
  },
  moneyLine1x2AwayYesRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2AwayNoRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2HomeYesRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2HomeNoRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2DrawYesRiskWin: {
    type: Object,
    required: true,
  },
  moneyLine1x2DrawNoRiskWin: {
    type: Object,
    required: true,
  },
  moneyline1x2Risk: {
    type: Object,
    required: true,
  },
  groupedBets: {
    type: Object,
    required: true,
  },
  league: {
    type: String,
    default: '',
  },
});

//CONST
const userStore = useUserStore();
const store = useMiscStore();
const stage = ref(1);
const session = ref({});
const awayYes = ref([]);
const awayNo = ref([]);
const homeYes = ref([]);
const homeNo = ref([]);
const drawYes = ref([]);
const drawNo = ref([]);
const dataAwayYes = ref(false);
const dataAwayNo = ref(false);
const dataHomeYes = ref(false);
const dataHomeNo = ref(false);
const dataDrawYes = ref(false);
const dataDrawNo = ref(false);
const groupedMoneyLines1x2 = ref(null);
const myMoneyLine1x2AwayYes = ref('');
const myMoneyLine1x2AwayNo = ref('');
const myMoneyLine1x2HomeYes = ref('');
const myMoneyLine1x2HomeNo = ref('');
const myMoneyLine1x2DrawYes = ref('');
const myMoneyLine1x2DrawNo = ref('');
const moneyLine1x2NameAwayYes = ref('');
const moneyLine1x2NameAwayNo = ref('');
const moneyLine1x2NameHomeYes = ref('');
const moneyLine1x2NameHomeNo = ref('');
const moneyLine1x2NameDrawYes = ref('');
const moneyLine1x2NameDrawNo = ref('');
const awayYesRiskWin = ref([]);
const awayNoRiskWin = ref([]);
const homeYesRiskWin = ref([]);
const homeNoRiskWin = ref([]);
const drawYesRiskWin = ref([]);
const drawNoRiskWin = ref([]);
const loading = ref(true);

//HOOK
onMounted(() => {
  awayYes.value = [Object.assign({}, props.moneyLine1x2AwayYes)];
  awayNo.value = [Object.assign({}, props.moneyLine1x2AwayNo)];
  awayYes.value = Object.assign([], awayYes.value);
  awayNo.value = Object.assign([], awayNo.value);
  homeYes.value = [Object.assign({}, props.moneyLine1x2HomeYes)];
  homeNo.value = [Object.assign({}, props.moneyLine1x2HomeNo)];
  homeYes.value = Object.assign([], homeYes.value);
  homeNo.value = Object.assign([], homeNo.value);
  drawYes.value = [Object.assign({}, props.moneyLine1x2DrawYes)];
  drawNo.value = [Object.assign({}, props.moneyLine1x2DrawNo)];
  drawYes.value = Object.assign([], drawYes.value);
  drawNo.value = Object.assign([], drawNo.value);
  myMoneyLine1x2AwayYes.value = Object.keys(awayYes.value[0]);
  myMoneyLine1x2AwayNo.value = Object.keys(awayNo.value[0]);
  myMoneyLine1x2HomeYes.value = Object.keys(homeYes.value[0]);
  myMoneyLine1x2HomeNo.value = Object.keys(homeNo.value[0]);
  myMoneyLine1x2DrawYes.value = Object.keys(drawYes.value[0]);
  myMoneyLine1x2DrawNo.value = Object.keys(drawNo.value[0]);

  if (myMoneyLine1x2AwayYes.value[0]) {
    moneyLine1x2NameAwayYes.value =
      awayYes.value[0][0].game.participants[0].longName;
    awayYesRiskWin.value = props.moneyLine1x2AwayYesRiskWin;
    dataAwayYes.value = true;
  }
  if (myMoneyLine1x2AwayNo.value[0]) {
    moneyLine1x2NameAwayNo.value =
      awayNo.value[0][0].game.participants[0].longName;
    awayNoRiskWin.value = props.moneyLine1x2AwayNoRiskWin;
    dataAwayNo.value = true;
  }
  if (myMoneyLine1x2HomeYes.value[0]) {
    moneyLine1x2NameHomeYes.value =
      homeYes.value[0][0].game.participants[1].longName;
    homeYesRiskWin.value = props.moneyLine1x2HomeYesRiskWin;
    dataHomeYes.value = true;
  }
  if (myMoneyLine1x2HomeNo.value[0]) {
    moneyLine1x2NameHomeNo.value =
      homeNo.value[0][0].game.participants[1].longName;
    homeNoRiskWin.value = props.moneyLine1x2HomeNoRiskWin;
    dataHomeNo.value = true;
  }
  if (myMoneyLine1x2DrawYes.value[0]) {
    moneyLine1x2NameDrawYes.value =
      drawYes.value[0][0].game.participants[0].longName;
    drawYesRiskWin.value = props.moneyLine1x2DrawYesRiskWin;
    dataDrawYes.value = true;
  }
  if (myMoneyLine1x2DrawNo.value[0]) {
    moneyLine1x2NameDrawNo.value =
      drawNo.value[0][0].game.participants[0].longName;
    drawNoRiskWin.value = props.moneyLine1x2DrawNoRiskWin;
    dataDrawNo.value = true;
  }
  loading.value = false;

  groupByMoneyLine1x2();
});

function getBestSideBet(yesObject, noObject) {
  const accumNoRisk =
    noObject.sumRiskBets !== undefined ? parseFloat(noObject.sumRiskBets) : 0;
  const accumNoWin =
    noObject.sumWinBets !== undefined ? parseFloat(noObject.sumWinBets) : 0;
  const accumYesRisk =
    yesObject.sumRiskBets !== undefined ? parseFloat(yesObject.sumRiskBets) : 0;
  const accumYesWin =
    yesObject.sumWinBets !== undefined ? parseFloat(yesObject.sumWinBets) : 0;

  const winYesMinusRiskNo = accumYesWin - accumNoRisk;
  const winNoMinusRiskYes = accumNoWin - accumYesRisk;

  const objBigWin =
    winNoMinusRiskYes > winYesMinusRiskNo ? noObject : yesObject;

  let calculatedRisk;
  let calculatedWin;

  if (
    (accumNoRisk === 0 && accumNoWin === 0) ||
    (accumYesRisk === 0 && accumYesWin === 0)
  ) {
    calculatedRisk = accumNoRisk !== 0 ? accumNoRisk : accumYesRisk;
    calculatedWin = accumNoWin !== 0 ? accumNoWin : accumYesWin;
  } else if (accumYesWin - accumNoRisk > accumNoWin - accumYesRisk) {
    calculatedRisk = accumYesRisk - accumNoWin;
    calculatedWin = accumYesWin - accumNoRisk;
  } else if (accumNoWin - accumYesRisk > accumYesWin - accumNoRisk) {
    calculatedRisk = accumNoRisk - accumYesWin;
    calculatedWin = accumNoWin - accumYesRisk;
  }

  const risk = fixed2(calculatedRisk);
  const win = fixed2(calculatedWin);
  const odds = calculateAvgOddsMoneyLines1x2(calculatedRisk, calculatedWin);
  return {
    moneyLine1x2Name: `${objBigWin.bets[0].side.toUpperCase()} ${objBigWin.participantInfo.longName}`,
    moneyLine1x2: objBigWin.realMoneyLine,
    odds,
    risk,
    win,
  };
}

function groupByMoneyLine1x2() {
  if (
    !dataAwayYes.value &&
    !dataAwayNo.value &&
    !dataHomeYes.value &&
    !dataHomeNo.value &&
    !dataDrawYes.value &&
    !dataDrawNo.value
  ) {
    return false;
  }

  const grouped = {
    0: {
      homeYes: false,
      homeNo: false,
      awayYes: false,
      awayNo: false,
      drawYes: false,
      drawNo: false,
      mySide: false,
      mySideAway: false,
      mySideHome: false,
      mySideAway: false,
      expandedAway: true,
      expandedHome: true,
      expandedDraw: true,
    },
  };

  if (props.groupedBets.moneyline1x2.homeYes) {
    const { sumRiskBets, sumWinBets, participantInfo, gameObj } =
      reduceRiskWinByBet(props.groupedBets.moneyline1x2.homeYes);
    const objHomeYes = {
      bets: props.groupedBets.moneyline1x2.homeYes,
      sumRiskBets,
      sumWinBets,
      realMoneyLine: 0,
      participantInfo,
      gameObj,
      avgOdds: calculateAvgOddsMoneyLines1x2(sumRiskBets, sumWinBets),
    };
    grouped[0].homeYes = objHomeYes;
  }

  if (props.groupedBets.moneyline1x2.homeNo) {
    const { sumRiskBets, sumWinBets, participantInfo, gameObj } =
      reduceRiskWinByBet(props.groupedBets.moneyline1x2.homeNo);
    const objHomeNo = {
      bets: props.groupedBets.moneyline1x2.homeNo,
      sumRiskBets,
      sumWinBets,
      realMoneyLine: 0,
      participantInfo,
      gameObj,
      avgOdds: calculateAvgOddsMoneyLines1x2(sumRiskBets, sumWinBets),
    };

    grouped[0].homeNo = objHomeNo;
  }

  if (props.groupedBets.moneyline1x2.awayYes) {
    const { sumRiskBets, sumWinBets, participantInfo, gameObj } =
      reduceRiskWinByBet(props.groupedBets.moneyline1x2.awayYes);
    const objAwayYes = {
      bets: props.groupedBets.moneyline1x2.awayYes,
      sumRiskBets,
      sumWinBets,
      realMoneyLine: 0,
      participantInfo,
      gameObj,
      avgOdds: calculateAvgOddsMoneyLines1x2(sumRiskBets, sumWinBets),
    };

    grouped[0].awayYes = objAwayYes;
  }

  if (props.groupedBets.moneyline1x2.awayNo) {
    const { sumRiskBets, sumWinBets, participantInfo, gameObj } =
      reduceRiskWinByBet(props.groupedBets.moneyline1x2.awayNo);
    const objAwayNo = {
      bets: props.groupedBets.moneyline1x2.awayNo,
      sumRiskBets,
      sumWinBets,
      realMoneyLine: 0,
      participantInfo,
      gameObj,
      avgOdds: calculateAvgOddsMoneyLines1x2(sumRiskBets, sumWinBets),
    };

    grouped[0].awayNo = objAwayNo;
  }

  if (props.groupedBets.moneyline1x2.drawYes) {
    const { sumRiskBets, sumWinBets, participantInfo, gameObj } =
      reduceRiskWinByBet(props.groupedBets.moneyline1x2.drawYes);
    const objDrawYes = {
      bets: props.groupedBets.moneyline1x2.drawYes,
      sumRiskBets,
      sumWinBets,
      realMoneyLine: 0,
      participantInfo,
      gameObj,
      avgOdds: calculateAvgOddsMoneyLines1x2(sumRiskBets, sumWinBets),
    };

    grouped[0].drawYes = objDrawYes;
  }

  if (props.groupedBets.moneyline1x2.drawNo) {
    const { sumRiskBets, sumWinBets, participantInfo, gameObj } =
      reduceRiskWinByBet(props.groupedBets.moneyline1x2.drawNo);
    const objDrawNo = {
      bets: props.groupedBets.moneyline1x2.drawNo,
      sumRiskBets,
      sumWinBets,
      realMoneyLine: 0,
      participantInfo,
      gameObj,
      avgOdds: calculateAvgOddsMoneyLines1x2(sumRiskBets, sumWinBets),
    };
    grouped[0].drawNo = objDrawNo;
  }
  grouped[0].mySideAway =
    grouped[0].awayYes || grouped[0].awayNo
      ? getBestSideBet(grouped[0].awayYes, grouped[0].awayNo)
      : false;
  grouped[0].mySideHome =
    grouped[0].homeYes || grouped[0].homeNo
      ? getBestSideBet(grouped[0].homeYes, grouped[0].homeNo)
      : false;
  grouped[0].mySideDraw =
    grouped[0].drawYes || grouped[0].drawNo
      ? getBestSideBet(grouped[0].drawYes, grouped[0].drawNo)
      : false;

  return (groupedMoneyLines1x2.value = grouped);
}

function calculateAvgOddsMoneyLines1x2(risk, win) {
  const avgOdds = calculateAverageOdds(risk, win);
  const avgOddsABS =
    Number.isNaN(avgOdds) || Math.abs(avgOdds) === Infinity ? 0 : avgOdds;
  return avgOddsABS > -100 && avgOddsABS < 100 ? 0 : fixed2(avgOddsABS);
}

function reduceRiskWinByBet(bets) {
  let sumRiskBets = 0;
  let sumWinBets = 0;
  let participantInfo;
  let gameObj;

  if (userStore.user.viewOddsWithCommission) {
    bets.forEach((bet) => {
      const betRisk =
        bet.origin === 'offer'
          ? bet.bet
          : commissionAdjustedRisk(
              bet.bet,
              bet.odds,
              bet.game.league.toLowerCase(),
              'moneyline1x2',
              userStore,
            );
      const tempWin = calculateWin(bet.bet, bet.odds);
      const betWin =
        bet.origin === 'offer'
          ? tempWin
          : commissionAdjustedWin(
              tempWin,
              bet.game.league.toLowerCase(),
              'moneyline1x2',
              userStore,
            );
      sumRiskBets += betRisk;
      sumWinBets += betWin;
      if (bet.market !== 'draw') {
        participantInfo = bet.game.participants.find(
          (p) => p.id === bet.market,
        );
      } else {
        participantInfo = {};
        participantInfo.longName = getDrawLabel(bet.game);
      }
      gameObj = bet.game;
    });
  } else {
    bets.forEach((bet) => {
      sumRiskBets += bet.bet;
      sumWinBets += calculateWin(bet.bet, bet.odds);
      if (bet.market !== 'draw') {
        participantInfo = bet.game.participants.find(
          (p) => p.id === bet.market,
        );
      } else {
        participantInfo = {};
        participantInfo.longName = getDrawLabel(bet.game);
      }
      gameObj = bet.game;
    });
  }
  return {
    sumRiskBets: fixed2(sumRiskBets),
    sumWinBets: fixed2(sumWinBets),
    participantInfo,
    gameObj,
  };
}

function changeAccordeonOpened(key) {
  switch (key.homeAway) {
    case 'away':
      groupedMoneyLines1x2.value[0].expandedAway =
        !groupedMoneyLines1x2.value[0].expandedAway;
      break;
    case 'home':
      groupedMoneyLines1x2.value[0].expandedHome =
        !groupedMoneyLines1x2.value[0].expandedHome;
      break;
    case 'draw':
      groupedMoneyLines1x2.value[0].expandedDraw =
        !groupedMoneyLines1x2.value[0].expandedDraw;
      break;
    default:
      break;
  }
}

//EMITTERS
//local
const emit = defineEmits(['close-modal']);

function close() {
  emit('close-modal');
}
//global
function displayBet(moneyLine) {
  session.value = moneyLine;
  emitter.emit('displayBet', session.value);
  loading.value = false;
  stage.value = 2;
}
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/scss/tokens.scss' as main;

.container-positions {
  padding-left: 20px;
  padding-right: 20px;
}

.box-position {
  border-radius: 8px;
  background: main.$white_01;
  margin: 0;
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: 16px;
}

.title-position {
  background: main.$blue-702;
  color: main.$white;
  font-size: small;
  font-weight: bold;
  padding: 8px;
  margin: 0;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  cursor: pointer;
}

.spacing-vertical-1 {
  height: 12px;
}

.betWin {
  background: main.$green-402;
}

.betLoss {
  background: main.$red-101;
}

.betDraw {
  background: main.$yellow-090;
}

//.betHalfWin
//   background: lightgreen

.betNormal {
  background: main.$black;
}

.bet {
  color: main.$blue-1100;
  font-size: small;
  margin: 0;
  width: 100%;
  border-top: 1px solid main.$grey-1000;
  background: main.$white;

  &-main-info {
    text-transform: uppercase;
    font-weight: main.$font-weight-bold;
    color: main.$color-primary;
    font-size: main.$font-size-sm;
  }

  &-risk {
    font-size: main.$font-size-sm;
    color: main.$blue-1100;
    font-weight: main.$font-weight-bold;
  }

  &-type {
    font-size: main.$font-size-sm;
    color: main.$blue-1100;
    font-weight: main.$font-weight-bold;
  }

  &-plus {
    font-size: main.$font-size-sm;
    color: main.$white;
    cursor: pointer;
    font-weight: main.$font-weight-bold;
  }

  &-time {
    font-size: x-small;
    color: main.$blue-1100;
    font-weight: main.$font-weight-normal;
    text-transform: uppercase;
  }

  &-teams {
    font-size: x-small;

    @media screen and (max-width: map.get(main.$grid-breakpoints, sm)) {
      display: none;
    }
  }

  &-small {
    font-size: x-small;
    text-transform: uppercase;
  }
}

.win,
.lose,
.cancelled,
.refunded {
  margin: 0;
  padding: 0.35rem 2rem;
  display: inline-block;
  font-family: inherit;
  border-radius: 4px;
  font-size: main.$font-size-xs;
  color: main.$white;
}

.win {
  background: main.$green-500;
}

.lose {
  background: main.$red-500;
}

.smallText {
  display: none;
}

.cancelled,
.refunded {
  background: main.$grey-1701;
}

.bar-separate {
  text-align: center;
  font-size: 12px;
  color: main.$blue-201;
}

.button-back {
  width: 100%;
  background: main.$grey-500;
  color: main.$blue-1100;
  font-weight: bold;
}

svg[data-icon='chevron-up'],
svg[data-icon='chevron-down'] {
  color: main.$white;
}

svg[data-icon='plus'] {
  padding: 2px;
  font-size: 12px;
  background: main.$blue-404;
  border-radius: 360px;
}

svg[data-icon='plus']:hover {
  opacity: 0.9;
}

.short-info {
  font-size: small;
  font-weight: bold;
  color: main.$blue-702;
  text-align: center;
}

.jump {
  min-width: 10%;
}

.iconAccordeon {
  color: main.$color-primary;
}
</style>
